export function money(n, cur = "$") {
  const v = Number(n || 0);
  return `${cur} ${v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const statusMeta = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
  sent: { label: "Sent", cls: "bg-blue-100 text-blue-800 dark:bg-blue-900/60 dark:text-blue-200" },
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/60 dark:text-emerald-200" },
  accepted: { label: "Accepted", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/60 dark:text-emerald-200" },
  rejected: { label: "Rejected", cls: "bg-rose-100 text-rose-800 dark:bg-rose-900/60 dark:text-rose-200" },
  cancelled: { label: "Cancelled", cls: "bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-200" },
};

export function shortDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
}

export function confidenceMeta(source, confidence) {
  if (source === "manual") return { label: "Manual", cls: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" };
  if (source === "ai" && confidence >= 85)
    return { label: `AI ${confidence}%`, cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/60 dark:text-emerald-200" };
  if (source === "ai" && confidence >= 60)
    return { label: `AI ${confidence}%`, cls: "bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-200" };
  if (source === "ai")
    return { label: `AI ${confidence}%`, cls: "bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-200" };
  return { label: "Unmatched", cls: "bg-rose-100 text-rose-800 dark:bg-rose-900/60 dark:text-rose-200" };
}
